import React from 'react';
import PropTypes from 'prop-types';
import classes from './styles.module.scss';
import { checkNegative } from '../../shared/checkNegative';

const Table = ({ columns, rows, second_class, tableRef }) => {


    return (
        <table className={`${classes.custom_table} ${second_class}`} ref={tableRef}>
            <thead>
                <tr>
                    {columns.map((column) => (
                        <th key={column?.label}>{column?.name}</th>
                    ))}
                </tr>
            </thead>
            <tbody>
                {rows?.map((row, rowIndex) => (
                    <tr key={row?.userName}>
                        {columns?.map((column) => (
                        <   td key={column?.label}>{checkNegative(row[column?.label])}</td>
                        ))}
                    </tr>
                ))}
            </tbody>
        </table>
    );
};

Table.propTypes = {
    tableRef : PropTypes.any,
    columns: PropTypes.arrayOf(
        PropTypes.shape({
        name: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        })
    ).isRequired,
    second_class:PropTypes.string,
    rows: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default Table;